// extracted by mini-css-extract-plugin
export default {"mobileOnly":"YS6c2","desktopOnly":"J2mcE"};